import { useSetMainFilter } from './publicCatalogFiltersHooks';
import { Big } from 'foundations-components/transitional/components/Big';
import { View } from 'foundations-components/transitional/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { filters } from './publicCatalogDropdownConstants';
import intersection from 'hs-lodash/intersection';
import difference from 'hs-lodash/difference';
import memoize from 'hs-lodash/memoize';
import { jsx as _jsx } from "react/jsx-runtime";
const sortAlphabetically = (a, b) => a.localeCompare(b);
export const sortOptions = options => options.sort(sortAlphabetically);
const getOptionHeading = heading => {
  return {
    disabled: true,
    use: 'unstyled',
    tabIndex: -1,
    label: /*#__PURE__*/_jsx(Big, {
      weight: "bold",
      children: heading
    })
  };
};
const useGetOption = () => {
  const setMainFilter = useSetMainFilter();
  const getOption = (filterName, optionName, isSubMenuOption = false, isAllOption = false) => {
    const isAllOptionLabel = isAllOption ? 'ALL_' : '';
    const handleOptionClick = () => {
      setMainFilter(filterName, optionName);
    };
    return {
      label: /*#__PURE__*/_jsx(View, {
        paddingInlineStart: !isSubMenuOption ? '400' : '200',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyPublic.catalogPage.filters.${filterName}.${isAllOptionLabel}${optionName}`
        })
      }),
      onClick: () => handleOptionClick()
    };
  };
  return getOption;
};
export const useGetSubMenu = () => {
  const getOption = useGetOption();
  const getSubMenu = (filterName, subMenuName, optionNames) => {
    const allOption = getOption(filterName, subMenuName, true, true);
    const options = sortOptions(optionNames).map(optionName => getOption(filterName, optionName, true));
    return {
      label: /*#__PURE__*/_jsx(View, {
        paddingInlineStart: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `academyPublic.catalogPage.filters.${filterName}.${subMenuName}`
        })
      }),
      options: [[allOption], options]
    };
  };
  return getSubMenu;
};
export const getSerializedOptions = memoize((filterName, optionsFromApi) => {
  const filter = filters[filterName];
  const validOptions = intersection(filter.allOptions, optionsFromApi);
  const marketingOptionsPresent = intersection(filter.marketingOptions, validOptions);
  const salesOptionsPresent = intersection(validOptions, filter.salesOptions);
  const serviceOptionsPresent = intersection(validOptions, filter.serviceOptions);
  const allSubOptionsPresent = [...marketingOptionsPresent, ...salesOptionsPresent, ...serviceOptionsPresent];
  const topLevelOptionsPresent = difference(validOptions, allSubOptionsPresent);
  return {
    marketingOptionsPresent,
    salesOptionsPresent,
    serviceOptionsPresent,
    topLevelOptionsPresent
  };
});
export const useGetFilterOptions = () => {
  const getOption = useGetOption();
  const getSubMenu = useGetSubMenu();
  const getFilterOptions = (filterName, optionsFromApi) => {
    const filter = filters[filterName];
    const {
      marketingOptionsPresent,
      salesOptionsPresent,
      serviceOptionsPresent,
      topLevelOptionsPresent
    } = getSerializedOptions(filterName, optionsFromApi);
    return [getOptionHeading( /*#__PURE__*/_jsx(FormattedMessage, {
      message: `academyPublic.catalogPage.filters.${filterName}.filterTitle`
    })), getSubMenu(filterName, filter.marketingSubMenuName, marketingOptionsPresent), getSubMenu(filterName, filter.salesSubMenuName, salesOptionsPresent), getSubMenu(filterName, filter.serviceSubMenuName, serviceOptionsPresent), topLevelOptionsPresent.sort(sortAlphabetically).map(optionName => getOption(filterName, optionName))];
  };
  return getFilterOptions;
};